import { render, staticRenderFns } from "./AppPopover.vue?vue&type=template&id=ea7b1ff0"
import script from "./AppPopover.vue?vue&type=script&lang=js"
export * from "./AppPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports